import React, { Component } from 'react';
import { Row } from 'react-bootstrap';

import Footer from './components/Footer';
import Navigation from './components/Navigation';
import PageRefRegistrar from './system/PageRefRegistrar'
import VideoModal from './components/VideoModal';

/**
 * Simply renders the main page
 */
export default class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showVideoModal: false,
            videoId: null
        };
    }

    componentDidMount() {
        var queryParams = this.props.location.query;

        // Register page referral
        new PageRefRegistrar().register(queryParams);
    }

    getVideoId() {
        return this.props.location.query.video;
    }

    showVideoModal() {
        return !! this.getVideoId()
    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="page-row">
                    <div className="container">
                        <Navigation />

                        <Row>
                            <VideoModal show={this.showVideoModal()} videoId={this.getVideoId()} />

                            {this.props.children}
                        </Row>
                    </div>
                </div>

                <div className="page-row push"></div>

                <div className="page-row">
                    <div className="container">
                        <Row>
                            <Footer />
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js